<template>
  <div id="totals" class="border-padding">
  <main>
    <div v-if="$route.params.type == 'player'">
      <h2>Player Stats</h2>
    </div>
    <div v-if="$route.params.type == 'team'">
      <h2>Team Stats</h2>
    </div>
    <div v-if="$route.params.type == 'opponent'">
      <h2>Opponent Stats</h2>
    </div>
    <div v-if="$route.params.type == 'lineup'">
      <h2>Lineup Stats</h2>
    </div>
    <div v-if="$route.params.type == 'lineup-opponent'">
      <h2>Lineup Opponent Stats</h2>
    </div>
    <div v-if="$route.params.type == 'lineup-player'">
      <h2>Lineup Player Stats</h2>
    </div>
    <div class="row">
      <div class="col-md-4" v-if="season_dropdown.data != undefined">
        <season-select v-model="seasons_selected" :options="season_dropdown"></season-select>
      </div>

      <div class="col-md-2" v-if="season_type_dropdown.data != undefined">
        <season-type-select v-model="season_type_selected" :options="season_type_dropdown"></season-type-select>
      </div>

      <div class="col-md-2" v-if="($route.params.type == 'team' || $route.params.type == 'opponent') && possession_start_dropdown.data != undefined && !date_filter && leverage_selected.length === 0">
        <possession-start-select v-model="possession_start_selected" :options="possession_start_dropdown"></possession-start-select>
      </div>

      <div class="col-md-1" v-if="team_dropdown.data != undefined && ($route.params.type == 'player' || $route.params.type == 'lineup' || $route.params.type == 'lineup-opponent')">
        <team-select v-model="team_selected" :options="team_dropdown"></team-select>
      </div>

      <div class="col-md-2" v-if="leverage_dropdown.data != undefined && ($route.params.league == 'nba' || $route.params.league == 'wnba') && starter_state_selected.length === 0 && !date_filter && ($route.params.type == 'player' || $route.params.type == 'team' || $route.params.type == 'opponent' || $route.params.type == 'lineup' || $route.params.type == 'lineup-opponent')">
        <label class="typo__label">{{ leverage_dropdown.label }}</label> <a href='https://darrylblackport.com/posts/2020-12-22-pbpstats-leverage/' target="_blank">(Details)</a>
        <multiselect
          v-model="leverage_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :options="leverage_dropdown.data"
          :searchable="false"
          :show-labels="false"
          placeholder=""
          :preselect-first="false"
          :allow-empty="true"
          :close-on-select="false"
          :multiple="true">
          <template slot="tag" slot-scope="props"><span class="custom__tag"><span>{{ props.option.text }}</span><span class="custom__remove" @click="props.remove(props.option)">❌</span></span></template>
        </multiselect>
      </div>

      <div class="col-md-2" v-if="starter_state_dropdown.data != undefined && leverage_selected.length === 0 && !date_filter && ($route.params.type == 'player' || $route.params.type == 'team' || $route.params.type == 'opponent')">
        <label class="typo__label">{{ starter_state_dropdown.label }}</label>
        <multiselect
          v-model="starter_state_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :options="starter_state_dropdown.data"
          :searchable="false"
          :show-labels="false"
          placeholder=""
          :preselect-first="false"
          :allow-empty="true"
          :close-on-select="false"
          :multiple="true">
          <template slot="tag" slot-scope="props"><span class="custom__tag"><span>{{ props.option.text }}</span><span class="custom__remove" @click="props.remove(props.option)">❌</span></span></template>
        </multiselect>
      </div>
    </div>

    <div v-if="date_filter" class="container-fluid">
      <span>Date Filter</span>
      <div class="row">
        <span>From: </span>
        <datepicker placeholder="Select Date" v-model="from_date" name="from_date" format="yyyy-MM-dd"></datepicker>
        <span>To: </span>
        <datepicker placeholder="Select Date" v-model="to_date" name="to_date" format="yyyy-MM-dd"></datepicker>
      </div>
    </div>

    <div class="row">
      <div class="border-padding container-fluid">
        <button class="" v-on:click="changeStats()">Get Stats</button>
        <button v-if="!date_filter" v-on:click="addDateFilter">Add Date Filter</button>
        <button v-if="date_filter" v-on:click="removeDateFilter">Remove Date Filter</button>
      </div>
      <div class="border-padding container-fluid" v-if="($route.params.type == 'team' || $route.params.type == 'opponent') && !date_filter">
        <b-form-checkbox id="checkbox1"
                     v-model="group_by_season"
                     value="true"
                     unchecked-value="false">
          Group Results By Season
        </b-form-checkbox>
      </div>
    </div>

    <div v-if="loading">
      Loading.....
    </div>
    <p style="color:red;" v-if="show_error_message">Error Getting Results</p>

    <div v-if="table_data_options.length > 0">
      <div class="row">
         <div class="col-md-2" v-if="stat_type_dropdown.data != undefined">
          <stat-type-select
            v-model="stat_type_selected"
            :options="stat_type_dropdown"
            :summary_table_data="single_row_table_data"
            :table_data="multi_row_table_data"
            :summary_totals="single_row_table_data_totals"
            :totals="multi_row_table_data_totals"
            :summary_per_100="single_row_table_data_per_100"
            :table_per_100="multi_row_table_data_per_100"
            :summary_per_game="single_row_table_data_per_game"
            :table_per_game="multi_row_table_data_per_game"
            :stat_table_data_options="table_data_options"
            :summary_columns="single_row_table_columns"
            :columns="multi_row_table_columns"
            :stat_type_change_func="changeStatType">
          </stat-type-select>
        </div>
        <div class="col-md-2">
          <stat-table-select v-model="stat_table_selected" :options="table_data_options"></stat-table-select>
        </div>
      </div>
      <div v-if="stat_table_selected != undefined && multi_row_table_data[stat_table_selected.id] != undefined">
        <div>
          <button type="button" @click="copyDirectLink">Copy Direct Link To Table</button>
        </div>
        <vue-good-table
          :columns="multi_row_table_columns[stat_table_selected.id]"
          :rows="multi_row_table_data[stat_table_selected.id]"
          :pagination-options="{ enabled: true, perPage: 30}"
          :searchOptions="{ enabled: false}"
          :sort-options="{ enabled: true}"
          :line-numbers="true"
          styleClass="vgt-table bordered striped">
          <template slot="table-row" slot-scope="props">
            <div v-if="props.column.field == 'Name' || props.column.field == 'ShortName'">
              <span :id="'popover-' + props.row.RowId + '-' + stat_table_selected.id" v-b-tooltip.hover title="Click For More">
                {{props.formattedRow[props.column.field]}}
              </span>
              <b-popover
                :target="'popover-' + props.row.RowId + '-' + stat_table_selected.id">
                <template slot="title">{{props.row.Name}}</template>
                <ul>
                  <li v-if="$route.params.type == 'lineup-player'"><router-link :to="{ name: 'game_logs', params: { league: $route.params.league, type: 'player' }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.EntityId}}">Game Logs</router-link></li>
                  <li v-else-if="group_by_season == 'true' && ($route.params.type == 'team' || $route.params.type == 'opponent')"><router-link :to="{ name: 'game_logs', params: { league: $route.params.league, type: $route.params.type }, query: {Season: props.formattedRow.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.EntityId}}">Game Logs</router-link></li>
                  <li v-else><router-link :to="{ name: 'game_logs', params: { league: $route.params.league, type: $route.params.type }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.EntityId}}">Game Logs</router-link></li>
                  <li v-if="$route.params.type == 'lineup'"><router-link :to="{ name: 'totals', params: { league: $route.params.league, type: 'lineup-player' }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, LineupId: props.row.EntityId}}">Player Stats</router-link></li>
                  <li v-if="$route.params.type == 'team' && group_by_season == 'true'"><router-link :to="{ name: 'assist_networks', params: { type: 'team', league: $route.params.league }, query: { Season: props.formattedRow.Season, SeasonType: $route.query.SeasonType, TeamId: props.row.EntityId }}">Assist Network</router-link></li>
                  <li v-if="$route.params.type == 'team' && group_by_season == 'false'"><router-link :to="{ name: 'assist_networks', params: { type: 'team', league: $route.params.league }, query: { Season: $route.query.Season, SeasonType: $route.query.SeasonType, TeamId: props.row.EntityId }}">Assist Network</router-link></li>
                  <li v-if="$route.params.type == 'lineup'"><router-link :to="{ name: 'assist_networks', params: { type: 'lineup', league: $route.params.league }, query: { Season: $route.query.Season, SeasonType: $route.query.SeasonType, LineupId: props.row.EntityId }}">Assist Network</router-link></li>
                  <li v-if="$route.params.type == 'team'"><router-link :to="{ name: 'season_stats', params: { league: $route.params.league }, query: { EntityType: 'Team', EntityId: props.row.EntityId }}">Stats By Season</router-link></li>
                  <li v-if="$route.params.type == 'lineup'"><router-link :to="{ name: 'season_stats', params: { league: $route.params.league }, query: { EntityType: 'Lineup', EntityId: props.row.EntityId }}">Stats By Season</router-link></li>
                  <li v-if="$route.params.type == 'lineup-opponent'"><router-link :to="{ name: 'season_stats', params: { league: $route.params.league }, query: { EntityType: 'LineupOpponent', EntityId: props.row.EntityId }}">Stats By Season</router-link></li>
                  <li v-if="$route.params.type == 'player'"><router-link :to="{ name: 'season_stats', params: { league: $route.params.league }, query: { EntityType: 'Player', EntityId: props.row.EntityId }}">Stats By Season</router-link></li>
                  <li v-if="$route.params.type == 'opponent'"><router-link :to="{ name: 'season_stats', params: { league: $route.params.league }, query: { EntityType: 'Opponent', EntityId: props.row.EntityId }}">Stats By Season</router-link></li>
                  <li v-if="$route.params.type == 'lineup'"><router-link :to="{ name: 'opponent_lineup_summary', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, TeamId: props.row.TeamId, LineupId: props.row.EntityId}}">Opponent Lineup Summary</router-link></li>
                  <li v-if="$route.params.type == 'lineup'"><router-link :to="{ name: 'wowy_combo_playing_time_distribution', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, TeamId: props.row.TeamId, PlayerIds: props.row.EntityId.split('-').join(','), OnlyShowAllPlayersOn: true}}">Playing Time Distribution</router-link></li>
                </ul>
              </b-popover>
            </div>
            <div v-else-if="$route.params.type == 'player' && props.column.field == 'Fg2aBlocked'">
              <span v-b-tooltip.hover :title="props.row['Name']">
                <router-link :to="{ name: 'shots', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.EntityId, EntityType: 'Player', TeamId: props.row.TeamId, Blocked: true, ShotValue: 2 }}">{{props.formattedRow[props.column.field]}}</router-link>
              </span>
            </div>
            <div v-else-if="$route.params.type == 'player' && props.column.field == 'Fg3aBlocked'">
              <span v-b-tooltip.hover :title="props.row['Name']">
                <router-link :to="{ name: 'shots', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.EntityId, EntityType: 'Player', TeamId: props.row.TeamId, Blocked: true, ShotValue: 3 }}">{{props.formattedRow[props.column.field]}}</router-link>
              </span>
            </div>
            <div v-else-if="$route.params.type == 'player' && props.column.field == 'PtsPutbacks'">
              <span v-b-tooltip.hover :title="props.row['Name']">
                <router-link :to="{ name: 'shots', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.EntityId, EntityType: 'Player', TeamId: props.row.TeamId, Assisted: false, ShotValue: 2, SecondsSinceOrebLte: 2 }}">{{props.formattedRow[props.column.field]}}</router-link>
              </span>
            </div>
            <div v-else-if="$route.params.type == 'player' && props.column.field == 'PtsAssisted2s'">
              <span v-b-tooltip.hover :title="props.row['Name']">
                <router-link :to="{ name: 'shots', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.EntityId, EntityType: 'Player', TeamId: props.row.TeamId, Assisted: true, ShotValue: 2 }}">{{props.formattedRow[props.column.field]}}</router-link>
              </span>
            </div>
            <div v-else-if="$route.params.type == 'player' && props.column.field == 'PtsUnassisted2s'">
              <span v-b-tooltip.hover :title="props.row['Name']">
                <router-link :to="{ name: 'shots', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.EntityId, EntityType: 'Player', TeamId: props.row.TeamId, Assisted: false, ShotValue: 2 }}">{{props.formattedRow[props.column.field]}}</router-link>
              </span>
            </div>
            <div v-else-if="$route.params.type == 'player' && props.column.field == 'PtsAssisted3s'">
              <span v-b-tooltip.hover :title="props.row['Name']">
                <router-link :to="{ name: 'shots', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.EntityId, EntityType: 'Player', TeamId: props.row.TeamId, Assisted: true, ShotValue: 3 }}">{{props.formattedRow[props.column.field]}}</router-link>
              </span>
            </div>
            <div v-else-if="$route.params.type == 'player' && props.column.field == 'PtsUnassisted3s'">
              <span v-b-tooltip.hover :title="props.row['Name']">
                <router-link :to="{ name: 'shots', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.EntityId, EntityType: 'Player', TeamId: props.row.TeamId, Assisted: false, ShotValue: 3 }}">{{props.formattedRow[props.column.field]}}</router-link>
              </span>
            </div>
            <div v-else-if="$route.params.type == 'player' && props.column.field == 'Assists'">
              <span v-b-tooltip.hover :title="props.row['Name']">
                <router-link :to="{ name: 'shots', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.TeamId, EntityType: 'Team', AssistPlayerId: props.row.EntityId }}">{{props.formattedRow[props.column.field]}}</router-link>
              </span>
            </div>
            <div v-else-if="$route.params.type == 'player' && props.column.field == '2ptAssists'">
              <span v-b-tooltip.hover :title="props.row['Name']">
                <router-link :to="{ name: 'shots', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.TeamId, EntityType: 'Team', AssistPlayerId: props.row.EntityId, ShotValue: 2 }}">{{props.formattedRow[props.column.field]}}</router-link>
              </span>
            </div>
            <div v-else-if="$route.params.type == 'player' && props.column.field == '3ptAssists'">
              <span v-b-tooltip.hover :title="props.row['Name']">
                <router-link :to="{ name: 'shots', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.TeamId, EntityType: 'Team', AssistPlayerId: props.row.EntityId, ShotValue: 3 }}">{{props.formattedRow[props.column.field]}}</router-link>
              </span>
            </div>
            <div v-else-if="$route.params.type == 'player' && props.column.field == 'AtRimAssists'">
              <span v-b-tooltip.hover :title="props.row['Name']">
                <router-link :to="{ name: 'shots', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.TeamId, EntityType: 'Team', AssistPlayerId: props.row.EntityId, ShotDistanceLte: 4}}">{{props.formattedRow[props.column.field]}}</router-link>
              </span>
            </div>
            <div v-else-if="$route.params.type == 'player' && props.column.field == 'ShortMidRangeAssists'">
              <span v-b-tooltip.hover :title="props.row['Name']">
                <router-link :to="{ name: 'shots', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.TeamId, EntityType: 'Team', AssistPlayerId: props.row.EntityId, ShotDistanceGte: 4, ShotDistanceLte: 14}}">{{props.formattedRow[props.column.field]}}</router-link>
              </span>
            </div>
            <div v-else-if="$route.params.type == 'player' && props.column.field == 'LongMidRangeAssists'">
              <span v-b-tooltip.hover :title="props.row['Name']">
                <router-link :to="{ name: 'shots', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.TeamId, EntityType: 'Team', AssistPlayerId: props.row.EntityId, ShotDistanceGte: 14, ShotValue: 2}}">{{props.formattedRow[props.column.field]}}</router-link>
              </span>
            </div>
            <div v-else-if="$route.params.type == 'player' && props.column.field == 'Corner3Assists'">
              <span v-b-tooltip.hover :title="props.row['Name']">
                <router-link :to="{ name: 'shots', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.TeamId, EntityType: 'Team', AssistPlayerId: props.row.EntityId, ShotType: 'Corner3'}}">{{props.formattedRow[props.column.field]}}</router-link>
              </span>
            </div>
            <div v-else-if="$route.params.type == 'player' && props.column.field == 'Arc3Assists'">
              <span v-b-tooltip.hover :title="props.row['Name']">
                <router-link :to="{ name: 'shots', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.TeamId, EntityType: 'Team', AssistPlayerId: props.row.EntityId, ShotType: 'Arc3'}}">{{props.formattedRow[props.column.field]}}</router-link>
              </span>
            </div>
            <div v-else-if="$route.params.type == 'player' && props.column.field == 'Blocks'">
              <span v-b-tooltip.hover :title="props.row['Name']">
                <router-link :to="{ name: 'shots', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.TeamId, EntityType: 'Opponent', BlockPlayerId: props.row.EntityId }}">{{props.formattedRow[props.column.field]}}</router-link>
              </span>
            </div>
            <div v-else-if="$route.params.type == 'player' && props.column.field == 'Blocked2s'">
              <span v-b-tooltip.hover :title="props.row['Name']">
                <router-link :to="{ name: 'shots', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.TeamId, EntityType: 'Opponent', BlockPlayerId: props.row.EntityId, ShotValue: 2 }}">{{props.formattedRow[props.column.field]}}</router-link>
              </span>
            </div>
            <div v-else-if="$route.params.type == 'player' && props.column.field == 'Blocked3s'">
              <span v-b-tooltip.hover :title="props.row['Name']">
                <router-link :to="{ name: 'shots', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.TeamId, EntityType: 'Opponent', BlockPlayerId: props.row.EntityId, ShotValue: 3 }}">{{props.formattedRow[props.column.field]}}</router-link>
              </span>
            </div>
            <div v-else-if="$route.params.type == 'player' && props.column.field == 'BlockedAtRim'">
              <span v-b-tooltip.hover :title="props.row['Name']">
                <router-link :to="{ name: 'shots', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.TeamId, EntityType: 'Opponent', BlockPlayerId: props.row.EntityId, ShotDistanceLte: 4}}">{{props.formattedRow[props.column.field]}}</router-link>
              </span>
            </div>
            <div v-else-if="$route.params.type == 'player' && props.column.field == 'BlockedShortMidRange'">
              <span v-b-tooltip.hover :title="props.row['Name']">
                <router-link :to="{ name: 'shots', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.TeamId, EntityType: 'Opponent', BlockPlayerId: props.row.EntityId, ShotDistanceGte: 4, ShotDistanceLte: 14}}">{{props.formattedRow[props.column.field]}}</router-link>
              </span>
            </div>
            <div v-else-if="$route.params.type == 'player' && props.column.field == 'BlockedLongMidRange'">
              <span v-b-tooltip.hover :title="props.row['Name']">
                <router-link :to="{ name: 'shots', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.TeamId, EntityType: 'Opponent', BlockPlayerId: props.row.EntityId, ShotDistanceGte: 14, ShotValue: 2}}">{{props.formattedRow[props.column.field]}}</router-link>
              </span>
            </div>
            <div v-else-if="$route.params.type == 'player' && props.column.field == 'BlockedCorner3'">
              <span v-b-tooltip.hover :title="props.row['Name']">
                <router-link :to="{ name: 'shots', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.TeamId, EntityType: 'Opponent', BlockPlayerId: props.row.EntityId, ShotType: 'Corner3'}}">{{props.formattedRow[props.column.field]}}</router-link>
              </span>
            </div>
            <div v-else-if="$route.params.type == 'player' && props.column.field == 'BlockedArc3'">
              <span v-b-tooltip.hover :title="props.row['Name']">
                <router-link :to="{ name: 'shots', params: { league: $route.params.league }, query: {Season: $route.query.Season, SeasonType: $route.query.SeasonType, EntityId: props.row.TeamId, EntityType: 'Opponent', BlockPlayerId: props.row.EntityId, ShotType: 'Arc3'}}">{{props.formattedRow[props.column.field]}}</router-link>
              </span>
            </div>
            <div v-else>
              <span v-b-tooltip.hover :title="props.row['Name']">
                {{props.formattedRow[props.column.field]}}
              </span>
            </div>
          </template>
          <template slot="table-column" slot-scope="props">
            <span v-if="props.column.hover != undefined" v-b-tooltip.hover :title="props.column.hover">
              {{props.column.label}}
            </span>
            <span v-else>
              {{props.column.label}}
            </span>
          </template>
        </vue-good-table>

        <span v-if="multi_row_table_data[stat_table_selected.id].length == 500 && !($route.params.type == 'team' || $route.params.type == 'opponent')" style="font-size: 10pt">If there are more than 500 results, only the top 500 in minutes played will be shown in table</span>

        <div v-if="single_row_table_data.Points != undefined">
          <h2>Totals</h2>

          <vue-good-table
            :columns="single_row_table_columns[stat_table_selected.id]"
            :rows="[single_row_table_data]"
            :sort-options="{ enabled: false}"
            styleClass="vgt-table bordered">
            <template slot="table-row" slot-scope="props">
              <span v-if="props.formattedRow[props.column.field] == ''">
                0
              </span>
              <span v-else>
                {{props.formattedRow[props.column.field]}}
              </span>
            </template>
            <template slot="table-column" slot-scope="props">
              <span v-if="props.column.hover != undefined" v-b-tooltip.hover :title="props.column.hover">
                {{props.column.label}}
              </span>
              <span v-else>
                {{props.column.label}}
              </span>
            </template>
          </vue-good-table>
        </div>
        <div>
          <vue-csv-downloader
            :data="multi_row_table_data[stat_table_selected.id]"
            :fields="csvHeaders"
            download-name="pbpstats_export.csv">
            Export CSV
          </vue-csv-downloader>
        </div>
      </div>
    </div>

  </main>
  </div>
</template>

<script>
import axios from 'axios'
import GetDropdownOptions from './mixins/get_dropdown'
import Multiselect from 'vue-multiselect'
import Datepicker from 'vuejs-datepicker'
import VueCsvDownloader from 'vue-csv-downloader'
import { rateStats } from './mixins/rate_stats'
import { statTypeOptions } from './mixins/stat_type_options'
import { tableDataOptions } from './mixins/table_data_options'
import { tableUtils } from './mixins/table_utils'
import { totalHeaders } from './mixins/table_headers'
import SeasonTypeSelect from './mixins/SeasonTypeSelect.vue'
import SeasonSelect from './mixins/SeasonSelect.vue'
import TeamSelect from './mixins/TeamSelect.vue'
import PossessionStartSelect from './mixins/PossessionStartSelect.vue'
import StatTypeSelect from './mixins/StatTypeSelect.vue'
import StatTableSelect from './mixins/StatTableSelect.vue'
import { season, seasonType, starterState, startType, leverage } from './mixins/dropdowns'

export default {
  name: 'Totals',
  components: {
    Multiselect,
    Datepicker,
    VueCsvDownloader,
    SeasonTypeSelect,
    SeasonSelect,
    TeamSelect,
    PossessionStartSelect,
    StatTypeSelect,
    StatTableSelect
  },
  mixins: [
    rateStats,
    tableUtils,
    totalHeaders,
    statTypeOptions,
    tableDataOptions,
    SeasonTypeSelect,
    SeasonSelect,
    TeamSelect,
    PossessionStartSelect,
    StatTypeSelect,
    StatTableSelect,
    GetDropdownOptions,
    season,
    seasonType,
    starterState,
    startType,
    leverage
  ],
  data () {
    return {
      loading: false,
      season_dropdown: {},
      stat_type_dropdown: {},
      seasons_selected: [],
      season_type_dropdown: {},
      season_type_selected: undefined,
      season_selected_string: '',
      team_dropdown: {},
      team_selected: undefined,
      stat_type_selected: undefined,
      single_row_table_data: [],
      single_row_table_columns: {},
      multi_row_table_data: {},
      multi_row_table_columns: {},
      possession_start_selected: undefined,
      possession_start_dropdown: {},
      starter_state_dropdown: {},
      starter_state_selected: [],
      leverage_dropdown: {},
      leverage_selected: [],
      group_by_season: 'false',
      date_filter: false,
      to_date: undefined,
      from_date: undefined,
      use_min_filters: true,
      use_text_filters: true,
      show_error_message: false,
      stat_table_selected: undefined,
      table_data_options: [],
      direct_link: '',
      api_endpoint: 'get-totals/'
    }
  },
  created () {
    this.loadData()
  },
  watch: {
    '$route': 'updateData',
    '$parent.league': 'changeLeague',
    'starter_state_selected': 'useStarterState',
    'leverage_selected': 'useLeverage',
    'possession_start_selected': 'clearNonPossessionStart',
    'stat_table_selected': 'updateDirectLink',
    'stat_type_selected': 'updateDirectLink'
  },
  methods: {
    useStarterState () {
      if (this.starter_state_selected.length > 0 && (this.$route.params.type === 'team' || this.$route.params.type === 'opponent')) {
        if (this.possession_start_selected.id !== this.possession_start_dropdown.data[0].id) {
          this.possession_start_selected = this.possession_start_dropdown.data[0]
        }
        if (this.to_date || this.from_date) {
          this.removeDateFilter()
        }
      }
    },
    clearNonPossessionStart () {
      if (this.possession_start_selected) {
        if (this.possession_start_selected.id !== 'All') {
          if (this.starter_state_selected.length > 0) {
            this.starter_state_selected = []
          }
          if (this.leverage_selected.length > 0) {
            this.leverage_selected = []
          }
        }
      }
    },
    useLeverage () {
      if (this.leverage_selected.length > 0) {
        if (this.possession_start_selected && this.possession_start_selected.id !== this.possession_start_dropdown.data[0].id) {
          this.possession_start_selected = this.possession_start_dropdown.data[0]
        }
        if (this.to_date || this.from_date) {
          this.removeDateFilter()
        }
      }
    },
    changeLeague () {
      this.seasons_selected = []
      this.season_selected_string = ''
      this.team_selected = undefined
      this.multi_row_table_data = {}
      this.single_row_table_data = []
      this.multi_row_table_data_totals = []
      this.multi_row_table_data_per_100 = []
      this.multi_row_table_data_per_game = []
      this.single_row_table_data_totals = []
      this.single_row_table_data_per_100 = []
      this.single_row_table_data_per_game = []
      this.date_filter = false
      this.from_date = undefined
      this.to_date = undefined
      this.$router.push({name: 'totals', params: {league: this.$parent.league, type: this.$route.params.type}})
    },
    setTeamAndPossessionStartDropdown (response) {
      if (!(this.$route.params.type === 'team' || this.$route.params.type === 'opponent')) {
        this.possession_start_dropdown = {}
        this.team_dropdown = {
          label: 'Team',
          data: response.data.teams
        }
        if (this.$route.query.TeamId) {
          this.setTeamSelected()
        } else {
          this.team_selected = undefined
        }
      } else {
        this.team_dropdown = {}
        this.team_selected = undefined
        this.possession_start_dropdown = this.start_type_dropdown_options
        this.setPossessionStartType()
        if (!this.possession_start_selected) {
          this.possession_start_selected = this.possession_start_dropdown.data[0]
        }
      }
    },
    setStarterStateDropdown () {
      if (this.$route.params.type === 'player' || this.$route.params.type === 'team' || this.$route.params.type === 'opponent') {
        this.starter_state_dropdown = this.starter_state_dropdown_options
        this.setStarterStateSelected()
      }
    },
    setLeverageDropdown () {
      if (this.$route.params.type === 'player' || this.$route.params.type === 'team' || this.$route.params.type === 'opponent' || this.$route.params.type === 'lineup' || this.$route.params.type === 'lineup-opponent') {
        this.leverage_dropdown = this.leverage_dropdown_options
        this.setLeverageSelected()
      }
    },
    setDateFilter () {
      var parts
      if (this.$route.query.FromDate) {
        this.addDateFilter()
        parts = this.$route.query.FromDate.split('-')
        this.from_date = new Date(parts[0], parts[1] - 1, parts[2])
      }
      if (this.$route.query.ToDate) {
        this.addDateFilter()
        parts = this.$route.query.ToDate.split('-')
        this.to_date = new Date(parts[0], parts[1] - 1, parts[2])
      }
    },
    setGroupBySeason () {
      if (this.$route.query.GroupBy === 'Season' && !this.date_filter) {
        this.group_by_season = 'true'
      }
    },
    checkIfStatsShouldBeLoaded () {
      if (this.seasons_selected.length > 0 && this.season_type_selected) {
        this.getStats()
      }
    },
    loadData () {
      this.date_filter = false
      this.from_date = undefined
      this.to_date = undefined
      this.group_by_season = 'false'
      this.seasons_selected = []
      this.season_selected_string = ''
      this.team_selected = undefined
      var params = {}
      if (this.$route.params.type === 'player' || this.$route.params.type === 'lineup' || this.$route.params.type === 'lineup-opponent') {
        this.use_min_filters = true
        if (this.$route.params.type === 'player') {
          params[this.$typeParam] = 'PlayerTotals'
        } else {
          params[this.$typeParam] = 'LineupTotals'
        }
      } else if (this.$route.params.type === 'lineup-player') {
        this.use_min_filters = false
      } else {
        params[this.$typeParam] = 'TeamTotals'
      }
      this.getDropdown([
        this.setSeasonDropdown,
        this.setSeasonTypeDropdown,
        this.setTeamAndPossessionStartDropdown,
        this.setStarterStateDropdown,
        this.setLeverageDropdown,
        this.setDateFilter,
        this.setGroupBySeason,
        this.checkIfStatsShouldBeLoaded
      ])
    },
    updateData () {
      this.multi_row_table_data = {}
      this.single_row_table_data = []
      this.multi_row_table_data_totals = []
      this.multi_row_table_data_per_100 = []
      this.multi_row_table_data_per_game = []
      this.single_row_table_data_totals = []
      this.single_row_table_data_per_100 = []
      this.single_row_table_data_per_game = []
      if (this.$route.query.Season && this.$route.query.SeasonType) {
        this.getStats()
      } else {
        this.loadData()
      }
    },
    addDateFilter () {
      if (!this.date_filter) {
        this.date_filter = true
        this.starter_state_selected = []
        this.leverage_selected = []
        this.possession_start_selected = undefined
      }
    },
    removeDateFilter () {
      this.date_filter = false
      this.to_date = undefined
      this.from_date = undefined
    },
    getStarterStateString () {
      var starterStateString = ''
      for (var i = 0; i < this.starter_state_selected.length; i++) {
        if (i === 0) {
          starterStateString += this.starter_state_selected[i].id
        } else {
          starterStateString += ',' + this.starter_state_selected[i].id
        }
      }
      return starterStateString
    },
    setStarterStateSelected () {
      this.starter_state_selected = []
      if (this.$route.query.StarterState) {
        this.starter_state_dropdown.data.forEach((starterStateOption) => {
          this.$route.query.StarterState.split(',').forEach((starterStateSelected) => {
            if (starterStateOption.id === starterStateSelected) {
              this.starter_state_selected.push(starterStateOption)
            }
          })
        })
      }
    },
    getLeverageString () {
      var leverageString = ''
      for (var i = 0; i < this.leverage_selected.length; i++) {
        if (i === 0) {
          leverageString += this.leverage_selected[i].id
        } else {
          leverageString += ',' + this.leverage_selected[i].id
        }
      }
      return leverageString
    },
    setLeverageSelected () {
      this.leverage_selected = []
      if (this.$route.query.Leverage) {
        this.leverage_dropdown.data.forEach((leverageOption) => {
          this.$route.query.Leverage.split(',').forEach((leverageSelected) => {
            if (leverageOption.id === leverageSelected) {
              this.leverage_selected.push(leverageOption)
            }
          })
        })
      }
    },
    changeStats () {
      var params = {}

      this.season_selected_string = this.getSeasonsSelectedString()
      params[this.$seasonParam] = this.season_selected_string
      params[this.$seasonTypeParam] = this.season_type_selected.id

      if (this.team_selected) {
        params[this.$teamIdParam] = this.team_selected.id
      }

      if (this.possession_start_selected && (this.$route.params.type === 'team' || this.$route.params.type === 'opponent')) {
        params[this.$startTypeParam] = this.possession_start_selected.id
      }

      if (this.group_by_season === 'true' && (this.$route.params.type === 'team' || this.$route.params.type === 'opponent') && !this.date_filter) {
        params[this.$groupByParam] = 'Season'
      }

      if (this.from_date) {
        params['FromDate'] = this.from_date.toISOString().split('T')[0]
        // only handle all start type for date filtering
        params[this.$startTypeParam] = 'All'
      }
      if (this.to_date) {
        params['ToDate'] = this.to_date.toISOString().split('T')[0]
        // only handle all start type for date filtering
        params[this.$startTypeParam] = 'All'
      }

      if (this.starter_state_selected.length > 0 && (this.$route.params.type === 'player' || this.$route.params.type === 'team' || this.$route.params.type === 'opponent')) {
        params[this.$starterStateParam] = this.getStarterStateString()
      }

      if (this.leverage_selected.length > 0 && (this.$route.params.type === 'player' || this.$route.params.type === 'team' || this.$route.params.type === 'opponent' || this.$route.params.type === 'lineup' || this.$route.params.type === 'lineup-opponent')) {
        params[this.$leverageParam] = this.getLeverageString()
      }

      this.$router.push({name: 'totals', query: params})
    },
    getStats () {
      this.show_error_message = false
      this.multi_row_table_data = {}
      this.single_row_table_data = []
      this.multi_row_table_data_totals = []
      this.multi_row_table_data_per_100 = []
      this.multi_row_table_data_per_game = []

      var params = this.$route.query

      if (this.$route.params.type === 'team') {
        params[this.$typeParam] = 'Team'
      } else if (this.$route.params.type === 'player') {
        params[this.$typeParam] = 'Player'
      } else if (this.$route.params.type === 'lineup') {
        params[this.$typeParam] = 'Lineup'
      } else if (this.$route.params.type === 'opponent') {
        params[this.$typeParam] = 'Opponent'
      } else if (this.$route.params.type === 'lineup-opponent') {
        params[this.$typeParam] = 'LineupOpponent'
      }

      this.api_endpoint = 'get-totals/'
      if (this.$route.params.type === 'lineup-player') {
        this.api_endpoint = 'get-lineup-player-stats/'
      }

      if (this.$route.params.type === 'player' || this.$route.params.type === 'lineup' || this.$route.params.type === 'lineup-opponent') {
        this.use_min_filters = true
      } else {
        this.use_min_filters = false
      }

      if (params.Season && params.SeasonType) {
        this.loading = true
        axios.get(process.env.API_BASE_URL + this.api_endpoint + this.$route.params.league, {
          params: params
        })
          .then((response) => {
            if (!response.data.error) {
              this.single_row_table_data = response.data.single_row_table_data
              this.single_row_table_data_totals = response.data.single_row_table_data
              this.multi_row_table_data_totals = response.data.multi_row_table_data

              if (this.$route.params.type === 'lineup-player') {
                var resultsHeaders = this.lineup_player_player_header
                var summaryHeaders = this.lineup_player_totals_header
              } else if (this.$route.params.type === 'team' || this.$route.params.type === 'opponent') {
                if (this.group_by_season === 'true') {
                  resultsHeaders = this.team_results_grouped_by_season_header
                } else {
                  resultsHeaders = this.team_results_header
                }
                summaryHeaders = this.team_summary_header
                if (this.$route.query.StartType === 'All') {
                  if (this.$route.query.StarterState === 'All' || this.$route.query.StarterState === undefined) {
                    if (this.$route.query.Leverage === undefined) {
                      if (this.group_by_season === 'true') {
                        resultsHeaders = this.team_results_start_type_no_starter_state_no_leverage_grouped_by_season_header
                      } else {
                        resultsHeaders = this.team_results_start_type_no_starter_state_no_leverage_header
                      }
                      summaryHeaders = this.team_summary_start_type_no_starter_state_no_leverage_header
                    }
                  } else {
                    if (this.group_by_season === 'true') {
                      resultsHeaders = this.team_results_start_type_with_starter_state_grouped_by_season_header
                    } else {
                      resultsHeaders = this.team_results_start_type_with_starter_state_header
                    }
                    summaryHeaders = this.team_summary_start_type_with_starter_state_header
                  }
                }
              } else if (this.$route.params.type === 'player') {
                if (this.$route.query.StarterState === 'All' || this.$route.query.StarterState === undefined) {
                  if (this.$route.query.Leverage === undefined) {
                    resultsHeaders = this.player_with_number_of_fouls_and_gp_results_header
                  } else {
                    resultsHeaders = this.player_with_number_of_fouls_results_header
                  }
                  summaryHeaders = this.player_with_number_of_fouls_summary_header
                } else {
                  resultsHeaders = this.player_results_header
                  summaryHeaders = this.player_summary_header
                }
              } else if (this.$route.params.type === 'lineup' || this.$route.params.type === 'lineup-opponent') {
                if (this.$route.query.Leverage === undefined) {
                  resultsHeaders = this.lineup_totals_no_leverage_header
                } else {
                  resultsHeaders = this.lineup_totals_with_leverage_header
                }
                summaryHeaders = this.lineup_summary_header
              }
              this.single_row_table_columns = summaryHeaders
              this.multi_row_table_columns = resultsHeaders

              if (this.$route.params.type === 'player' && (this.$route.query.StarterState === 'All' || this.$route.query.StarterState === undefined)) {
                var tableOptions = this.table_options_with_number_of_fouls
              } else {
                tableOptions = this.base_table_options
              }
              this.table_data_options = tableOptions

              if (this.$route.query.StartType === 'All' && (this.$route.query.StarterState === 'All' || this.$route.query.StarterState === undefined) && this.$route.query.Leverage === undefined) {
                this.stat_type_dropdown = this.options_with_per_game
              } else {
                // games played count won't be accuracte so don't allow for per game stats
                this.stat_type_dropdown = this.options_without_per_game
              }

              this.multi_row_table_data_totals.forEach((row) => {
                this.table_data_options.forEach((tableDataOption) => {
                  var values = this.setZerosAndSortFunction(this.multi_row_table_columns[tableDataOption.id], row)
                  row = values.row
                  this.multi_row_table_columns[tableDataOption.id] = values.columns
                })
              })

              this.setStatTypeValue()
              this.changeStatType()
              if (this.$route.query.Table) {
                this.setStatTableSelected()
              }
              this.updateDirectLink()
            } else {
              this.show_error_message = true
              this.single_row_table_data = {}
              this.single_row_table_data_totals = []
            }
            this.loading = false
          }, (error) => {
            this.show_error_message = true
            this.loading = false
            this.error = error
          })
      }
    },
    copyDirectLink: function () {
      this.$copyText(this.direct_link)
    },
    updateDirectLink () {
      var query = this.$route.query

      if (this.stat_table_selected) {
        query['Table'] = this.stat_table_selected.id
      }
      if (this.stat_type_selected) {
        query['StatType'] = this.stat_type_selected.id
      }
      var queryString = Object.keys(query).map(function (key) {
        return key + '=' + query[key]
      }).join('&')

      this.direct_link = window.location.origin + this.$route.path + '?' + queryString
    }
  },
  computed: {
    csvHeaders: function () {
      var headers = []
      this.multi_row_table_columns[this.stat_table_selected.id].forEach((column) => {
        headers.push(column.field)
      })
      return headers
    }
  }
}
</script>

<style scoped>
@import "https://maxcdn.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css"

</style>



// WEBPACK FOOTER //
// src/components/Totals.vue